import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  DataDefinitionList,
  Loader,
  Notification,
  Message
} from '../../web.common';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import {
  DisplayDate,
  DisplayGuid,
  DisplayStatus
} from '../items';
import { DetailsRightBar, NoLink, Link, Divider } from './DetailsRightBar';
import { crawlingStatus } from '../../enums/crawlingStatus';

class CrawlingInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      crawlingData: null
    };
  }

  async componentDidMount() {
    const { match: { params: { crawlingId } } } = this.props;
    const { api: { crawlings: { getCrawling } } } = this.props;

    try {
      const crawlingData = await getCrawling(crawlingId);
      this.setState({ crawlingData });
    }
    catch (e) {
      this.setState({ errorMessage: new Message('error', 'Unable to get data') });
    }
  }

  render() {
    const { match: { params: { crawlingId } } } = this.props;
    const { crawlingData, errorMessage } = this.state;

    let mappedData = null;

    if (crawlingData) {
      const {
        id,
        createdAt,
        productId,
        executedAt,
        startedAt,
        finishedAt,
        durationSeconds,
        input,
        output,
        status,
        logUrl
      } = crawlingData;

      mappedData = {
        Id: <DisplayGuid>{id}</DisplayGuid>,
        'Created At': <DisplayDate>{createdAt}</DisplayDate>,
        'Product Id': <DisplayGuid baseAnchor='/product'>{productId}</DisplayGuid>,
        ...(startedAt ? {} : { 'Executed At (legacy)': <DisplayDate>{executedAt}</DisplayDate> }),
        'Started At': startedAt ? <DisplayDate>{startedAt}</DisplayDate> : 'n/a',
        'Finished At': finishedAt ? <DisplayDate>{finishedAt}</DisplayDate> : 'n/a',
        'Duration (s)': durationSeconds != null ? durationSeconds : 'n/a',
        Status: <DisplayStatus mapping={crawlingStatus}>{status}</DisplayStatus>,
        'Details': <a
                      target='_blank'
                      rel='noopener noreferrer'
                      href={logUrl}
                    >
                      Link
                    </a>,
         input: input ? input : 'n/a',
         output: output ? { activityCount: output.activityCount , pagesCount: output.pagesCount, errorText: output.errorText ?? ''} : 'n/a'
      };
    }

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <Notification newMessage={errorMessage} />

            <div className='content-with-right-pane-delimiter'>
              <PageTop
                documentTitle='Crawling details'
                documentDescription='Crawling details'
              />

              <h2 className='main-page-header main-page-header-with-subheader'>
                Crawling
              </h2>
              <h5 className='main-page-subheader'>{crawlingId}</h5>
              <br />

              {
                mappedData ? (
                  <React.Fragment>
                    <DataDefinitionList
                      listData={mappedData}
                      classNames={['detail-page-list']}
                    />
                  </React.Fragment>
                ) : <Loader hasLoaded={false}>Loading...</Loader>
              }
            </div>

            <DetailsRightBar>
              <Divider>Links</Divider>
              {
                crawlingData ? <Link to={`/activities?crawlingId=${crawlingData.id}`}>Activities</Link> : ''
              }
              <Divider>Actions</Divider>
              <NoLink>None</NoLink>
            </DetailsRightBar>
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const Crawling = withRouter(withApi(connect(({ user }) => ({ isLoggedIn: !!user }), {})(CrawlingInternal)));

Crawling.requiresLogin = true;
Crawling.propTypes = { isLoggedIn: PropTypes.bool };

export default Crawling;